module.exports = __webpack_public_path__ + "static/media/chanel-allure-homme-sport-big.850b16b4.png";